import classnames from 'classnames';
import React from 'react';
import styles from '../../styles/widgets/points/vm-points-message.module.scss';
import { PurifiedHtmlContainer } from '../layout/purified-html-container';

export const InPageMessageComponent = React.memo(({ className, html }) => (
  <PurifiedHtmlContainer className={classnames(styles.widget, className)} html={html} />
));
